import { fetchJson } from '@/lib/api/api.helpers';
import type { ContactFormValues } from '@/lib/validation/contact.schema';
import { z } from 'zod';

export const contactResponseSchema = z.object({
  ok: z.literal(true),
  message: z.string(),
  requestId: z.string(),
});

export type ContactResponse = z.infer<typeof contactResponseSchema>;

export function sendContactMessageApi(payload: ContactFormValues): Promise<ContactResponse> {
  return fetchJson(
    `${import.meta.env.VITE_URL_API}/v1/public/contact`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    contactResponseSchema,
  );
}
